<template>
  <div class="checkbox">
    <input
      type="checkbox"
      :name="id"
      :id="id"
      class="checkbox__input"
      :disabled="disabled"
    />
    <label :for="id" class="checkbox__button"></label>
    <label :for="id" class="checkbox__label">
      {{ shortText }}
      <p class="checkbox__tooltip" v-if="longText">{{ longText }}</p>
    </label>
  </div>
</template>
<script>
export default {
  props: ['id', 'shortText', 'longText', 'disabled'],
};
</script>
<style lang="scss">
.checkbox {
  display: flex;
  align-items: center;
  margin: 2% 0;
}

.checkbox__input {
  visibility: hidden;
  position: absolute;
  opacity: 0;
  max-width: 1px;
  max-height: 1px;
  top: -1000px;
  left: -1000px;
}

.checkbox__button {
  width: 16px;
  height: 16px;

  margin-right: 8px;
  cursor: pointer;
  border: none;
  box-shadow: 0 0 2px rgba(#000, 0.4);
}

.checkbox__input:checked + .checkbox__button {
  background: $primaryColor;
}

.checkbox__label {
  position: relative;
  flex: 1;
  font-size: 9px;
  cursor: pointer;
  &:hover {
    .checkbox__tooltip {
      opacity: 1;
      visibility: visible;
    }
  }
}

.checkbox__tooltip {
  display: block;
  position: absolute;
  background: #fff;
  z-index: 40;
  width: 220%;
  max-width: 100%;
  bottom: calc(100% + 5px);
  padding: 0.7rem;
  box-shadow: 2px 2px 45px rgba(#000, 0.1);
  visibility: hidden;
  opacity: 0;
  transition: 200ms;
  font-size: 10px;
}
</style>
